export default "__VITE_ASSET__SdXEWiUI__"